import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Prospectos from './pages/Prospectos';
import Clientes from './pages/Clientes';
import Polizas from './pages/Polizas';
import Citas from './pages/Citas';
import Seguimientos from './pages/Seguimientos';
import Cotizaciones from './pages/Cotizaciones';
import Renovaciones from './pages/Renovaciones';
import Reportes from './pages/Reportes';
import Simulador from './pages/Simulador';
import Operaciones from './pages/Operaciones';
import ProspectoDetalle from './pages/ProspectoDetalle';
import Reclutamiento from './pages/Reclutamiento';
import Usuarios from './pages/Usuarios';
import MisPolizas from './pages/MisPolizas';
import Hoy from './pages/Hoy';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const DefaultRedirect = () => {
  const { user } = useAuth();
  if (user?.rol === 'Agente') return <Navigate to="/hoy" replace />;
  return <Navigate to="/prospectos" replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }>
            <Route index element={<DefaultRedirect />} />
            <Route path="prospectos" element={<Prospectos />} />
            <Route path="prospectos/:id" element={<ProspectoDetalle />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="polizas" element={<Polizas />} />
            <Route path="citas" element={<Citas />} />
            <Route path="agenda" element={<Citas />} />
            <Route path="seguimientos" element={<Seguimientos />} />
            <Route path="cotizaciones" element={<Cotizaciones />} />
            <Route path="renovaciones" element={<Renovaciones />} />
            <Route path="simulador" element={<Simulador />} />
            <Route path="reportes" element={<Reportes />} />
            <Route path="operaciones" element={<Operaciones />} />
            <Route path="reclutamiento" element={<Reclutamiento />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="mis-polizas" element={<MisPolizas />} />
            <Route path="hoy" element={<Hoy />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
